import React, { PropsWithChildren } from 'react';
import { FilterName, ISerpPlugin, PluginAPI } from '~/plugins/SerpPlugin';
import SRError from '~/utils/errors/srError';

const PluginContext = React.createContext<PluginAPI | undefined>(undefined);

const emptyPlugin = {
    getFilters: () => ({}),
    getActions: () => ({}),
    doAction: () => {
        return;
    },
    applyFilter: <Input,>(_filterName: FilterName, filteredValue: Input): Input => {
        return filteredValue;
    },
    name: '',
} satisfies PluginAPI;

export const PluginProvider: React.FC<PropsWithChildren<{ plugin: ISerpPlugin | null }>> = ({ plugin, children }) => {
    const pluginAPI =
        plugin === null
            ? emptyPlugin
            : {
                  getFilters: plugin.getFilters.bind(plugin),
                  getActions: plugin.getActions.bind(plugin),
                  doAction: plugin.doAction.bind(plugin),
                  applyFilter: plugin.applyFilter.bind(plugin),
                  name: plugin.name,
              };

    return <PluginContext.Provider value={pluginAPI}>{children}</PluginContext.Provider>;
};

export const usePlugin = (): PluginAPI => {
    const pluginAPI = React.useContext(PluginContext);
    if (pluginAPI === undefined) {
        throw new SRError('useAction must be used within a PluginProvider');
    }

    // console.log('actions', pluginAPI.getActions());
    // console.log('filters', pluginAPI.getFilters());

    return pluginAPI;
};
